<!-- 表二列表 -->

<template>
    <div class="ListCage Rtable8">
        <div class="tabTtl">
            <span>表 1-8：人员基本情况登记表</span>
            <div class="tabBtns">
                <el-button size="mini" @click="goBack">返回</el-button>
                <!-- <el-select v-model="value" clearable placeholder="历史版本列表" class="selectTime" @change="gethistory(value)">
            <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
            </el-option>
        </el-select> -->
            </div>
        </div>
        <div class="percentTab" v-if="role == 'show'">
            <table>
                <tr>
                    <td colspan="2">人数统计</td>
                    <td colspan="2">岗位培训合格证书持有统计</td>
                    <td colspan="2">出版专业职业资格证书持有情况统计</td>
                </tr>
                <tr>
                    <td>岗位类别</td>
                    <td>人员数（人）</td>

                    <td>持证人数</td>
                    <td>占比</td>

                    <td>中级以上</td>
                    <td>占比</td>
                </tr>

                <tr v-for="(term, inx) in percentArr">
                    <template v-if="inx < 2">
                        <td>{{ term.workerType | transStr('type') }}</td>
                        <td>{{ term.thisWorker }}</td>

                        <td>{{ term.certificateWorker }}</td>
                        <td rowspan="2" v-if="inx == 0">
                          <!-- {{ term | pecCount(percentArr, 1) }} -->
                          {{(munCount&&munCount.length>0)?munCount[0].certificateWorkerProportion:0}}
                        </td>

                        <td>{{ term.zjCertificate }}</td>
                        <td rowspan="2" v-if="inx == 0">{{ term | pecCount(percentArr, 2) }}</td>
                    </template>
                    <template v-else>
                        <td>{{ term.workerType | transStr('type') }}</td>
                        <td>{{ term.thisWorker }}</td>
                        <td> ———— </td>
                        <td> ———— </td>
                        <td>{{ term.zjCertificate }}</td>
                        <td>{{ term | pecCount(percentArr, 3) }}</td>
                    </template>

                </tr>

            </table>
        </div>
        <div class="ctrlsLine">
            <el-radio-group v-model="seekPms.type" @change="tabSeek('seek')">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">主要负责人</el-radio>
                <el-radio :label="2">其他负责人</el-radio>
                <el-radio :label="3">编辑人员</el-radio>
            </el-radio-group>
            <el-input v-model="seekPms.keyword" size="small" placeholder="通过姓名、身份证号、手机号查询"></el-input>
            <el-button class="seekBtn" @click="tabSeek('seek')" size="small">查询</el-button>
        </div>

        <div class="tabForms">
            <el-table :data="filterData(tabDat, seekPms).slice((currentPage - 1) * pageSize, currentPage * pageSize)" border
                style="width: 100%" v-loading="loading">
                <el-table-column label="序号" width="60" align="center" type="index">
                </el-table-column>
                <el-table-column prop="fullName" label="姓名" width="120" align="center">
                </el-table-column>
                <el-table-column label="性别" width="60" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.gender | translate('C017', dicMap) }}
                    </template>
                </el-table-column>
                <el-table-column prop="idNumber" label="身份证号（军官证号）" width="270" align="center">
                </el-table-column>
                <el-table-column label="职务" width="90" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.job | translate('C022', dicMap, scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="政治面貌" width="90" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.politicalStatus | translate('C006', dicMap) }}
                    </template>
                </el-table-column>
                <el-table-column label="文化程度" width="90" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.culture | translate('C005', dicMap) }}
                    </template>
                </el-table-column>
                <el-table-column prop="major" label="专业" width="90" align="center">
                </el-table-column>
                <el-table-column label="职称系列" width="90" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.professionalTitleSeries | translate('C007', dicMap) }}
                    </template>
                </el-table-column>
                <el-table-column label="职称级别" width="90" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.titleLevel | translate('C008', dicMap) }}
                    </template>
                </el-table-column>
                <el-table-column label="是否持有岗位培训资格证书" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type != 3" class="imgIcon"
                            @click="urlCreate('open', scope.row.trainCertificateId)">
                            {{ scope.row.isTrainCertificate | translate('C018', dicMap) }}
                            <i v-if="scope.row.trainCertificateId" class="el-icon-picture"></i>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="持有出版专业职业资格证书情况" align="center">
                    <template slot-scope="scope">
                        <span class="imgIcon" @click="urlCreate('open', scope.row.professionalCertificateId)">
                            {{ scope.row.certificateSituation | translate('C009', dicMap) }}
                            <i v-if="scope.row.professionalCertificateId" class="el-icon-picture"></i>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="cellphone" label="手机号" align="center">
                </el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="memberEdit(scope.row)" type="primary">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div v-show="value !== ''">
                <p v-show="value !== ''">历史版本：</p>
                <el-table :data="historyJsonParams" border style="width: 100%" v-loading="loading">
                    <el-table-column label="序号" width="60" align="center" type="index">
                    </el-table-column>
                    <el-table-column prop="fullName" label="姓名" width="120" align="center">
                    </el-table-column>
                    <el-table-column label="性别" width="60" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.gender | translate('C017', dicMap) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="idNumber" label="身份证号（军官证号）" width="270" align="center">
                    </el-table-column>
                    <el-table-column label="职务" width="90" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.job | translate('C022', dicMap, scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="政治面貌" width="90" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.politicalStatus | translate('C006', dicMap) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="文化程度" width="90" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.culture | translate('C005', dicMap) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="major" label="专业" width="90" align="center">
                    </el-table-column>
                    <el-table-column label="职称系列" width="90" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.professionalTitleSeries | translate('C007', dicMap) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="职称级别" width="90" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.titleLevel | translate('C008', dicMap) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="是否持有岗位培训资格证书" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type != 3" class="imgIcon"
                                @click="urlCreate('open', scope.row.trainCertificateId)">
                                {{ scope.row.isTrainCertificate | translate('C018', dicMap) }}
                                <i v-if="scope.row.trainCertificateId" class="el-icon-picture"></i>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="持有出版专业职业资格证书情况" align="center">
                        <template slot-scope="scope">
                            <span class="imgIcon" @click="urlCreate('open', scope.row.professionalCertificateId)">
                                {{ scope.row.certificateSituation | translate('C009', dicMap) }}
                                <i v-if="scope.row.professionalCertificateId" class="el-icon-picture"></i>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cellphone" label="手机号" align="center">
                    </el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="memberEdit(scope.row)" type="primary">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="headBar">
                <span>申报人信息</span>
            </div>
            <div class="editArea newEditArea" :class="value !== '' ? 'newStyle' : ''">
                <div class="editBox">
                    <p class="edName">申报人：</p>
                    <div class="edInp">
                        <el-input disabled size="small" v-model="declare.personnel"></el-input>
                    </div>
                </div>
                <div class="editBox">
                    <p class="edName">联系方式：</p>
                    <div class="edInp">
                        <el-input disabled size="small" v-model="declare.contact"></el-input>
                    </div>
                </div>
                <div class="editBox">
                    <p class="edName">申报时间：</p>
                    <div class="edInp">
                        <el-input disabled size="small" v-model="updatedAt"></el-input>
                    </div>
                </div>
            </div>
            <div class="editArea newEditArea" :class="value !== '' ? 'newStyle' : ''" v-show="value !== ''">
                <div class="editBox">
                    <p class="edName">申报人：</p>
                    <div class="edInp">
                        <el-input disabled size="small" v-model="declare.personnel"
                            :class="historyDeclare.personnel !== declare.personnel ? 'highlight' : ''">
                        </el-input>
                    </div>
                </div>
                <div class="editBox">
                    <p class="edName">联系方式：</p>
                    <div class="edInp">
                        <el-input disabled size="small" v-model="declare.contact"
                            :class="historyDeclare.contact !== declare.contact ? 'highlight' : ''">
                        </el-input>
                    </div>
                </div>
                <div class="editBox">
                    <p class="edName">申报时间：</p>
                    <div class="edInp">
                        <el-input disabled size="small" v-model="historyDeclare.updatedAt"
                            :class="historyDeclare.updatedAt !== updatedAt ? 'highlight' : ''">
                        </el-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="pageCage" v-if="pgAll > 1">
            <el-pagination @current-change="pageSent" :current-page='seekPms.no' layout="prev, pager, next"
				:page-count="pgAll">
            </el-pagination>
        </div>

        <el-dialog class="pressComDiag" title="" :visible.sync="dialogVisible" @close="urlCreate('close')">

            <!-- <div class="imgCont"> -->
            <img :src="imgShowUrl" width="100%" alt="">
            <!-- </div> -->

        </el-dialog>

    </div>
</template>

<script>
import initPagin from '@/mixins/initPagin'
import { getPfileUrl } from '@/api/pressRole/pressRole';
import {
    tabList8,
    tab8Remove,
    tab8Clean,
    dicSeek,
    percentCount,
    pSubmitHistoryList,
} from '@/api/pressRole/pressRole';
import {
    getFileToken
} from '@/api/account';
export default {
    mixins: [initPagin],
    data() {
        return {
            loading: false,
            tabDat: [],
            detArrs: [],
            dicMap: {},
            seekPms: {
                type: 0,
                keyword: '',
                no: 1,
                size: 15
            },

            pgAll: 0,

            percentArr: [],
            munCount: {},
            role: '',

            // 图片查看
            dialogVisible: false,
            imgShowUrl: '',
            declare: {
                personnel: "",
                contact: ""
            },
            updatedAt: '',
            historyJsonParams: [],
            historyJson: [],
            historyDeclare: {
                personnel: "",
                contact: "",
                updatedAt: ''
            },
            options: [],
            value: '',
        }
    },
    filters: {
        translate: function (dat, code, transMap, rowDat) {
            if (code == "C022" && transMap[code][dat] == '其他') {
                return rowDat.professionalOther;
            } else {
                return transMap[code][dat];
            }
        },
        transStr: function (dat, code) {
            if (code == 'type') {
                let map = {
                    1: "主要负责人",
                    2: "其他负责人",
                    3: "编辑人员"
                }

                return map[dat];
            }
        },
        pecCount: function (dat, arrDat, type) {
            if (type == 1) {
                if (arrDat[0].thisWorker + arrDat[1].thisWorker == 0) {
                    return '0%';
                } else {
                    var pct = (arrDat[0].certificateWorker + arrDat[1].certificateWorker) / (arrDat[0].thisWorker + arrDat[1].thisWorker);
                    pct = (pct * 100 + '').substr(0, 5) + '%';
                    return pct;
                }
            } else if (type == 2) {
                if (arrDat[0].thisWorker + arrDat[1].thisWorker == 0) {
                    return '0%';
                } else {
                    var pct = (arrDat[0].zjCertificate + arrDat[1].zjCertificate) / (arrDat[0].thisWorker + arrDat[1].thisWorker);
                    pct = (pct * 100 + '').substr(0, 5) + '%';
                    return pct;
                }
            } else if (type == 3) {
                if (arrDat[2].thisWorker == 0) {
                    return '0%';
                } else {
                    var pct = arrDat[2].zjCertificate / arrDat[2].thisWorker;
                    pct = (pct * 100 + '').substr(0, 5) + '%';
                    return pct;
                }

            }

        },
    },
    methods: {
        tabSeek: function (type) {
            if (type == 'seek') return
            this.loading = true;
            if (type == 'init') {
                this.seekPms.no = 1;
            }

            tabList8(this.seekPms).then(response => {
                let vm = this;
                vm.tabDat = [];

                let pages = 1;
                if (response.pworkerList.length > 0) {
                    pages = parseInt(response.pworkerList.length / vm.pageSize);
                    if (response.pworkerList.length % vm.pageSize > 0) {
                        pages += 1;
                    }
                }
                setTimeout(function () {
                    vm.loading = false;
                    vm.tabDat = response.pworkerList;
                    vm.pgAll = pages;
                    // undefine?
                    // if(response.pOrganizationPersonnel!==null){
                    if (response.pOrganizationPersonnel) {
                        vm.declare.contact = response.pOrganizationPersonnel.contact;
                        vm.declare.personnel = response.pOrganizationPersonnel.personnel;
                        vm.updatedAt = response.pOrganizationPersonnel.updatedAt;
                    }
                }, 300)
            })
        },

        selectionChange: function (selection) {
            let newArr = [];
            for (let i = 0; i < selection.length; i++) {
                newArr.push(selection[i].id);
            }
        },
        dictInit: function () {
            let nameArr = ['C017', 'C018', 'C006', 'C022', 'C005', 'C007', 'C008', 'C009'];
            let newPromise = this.$store.dispatch('dictUpdate', {
                codeArr: nameArr,
                type: 'map'
            });
            newPromise.then(result => {
                this.dicMap = result;
                this.tabSeek();
            })

            percentCount({ materialId: this.$route.query.mtId }).then(response => {
                console.debug('percentCount: ', response)
                //    let unFormate = response.workerproportion;
                let unFormate = response;
                this.percentArr = [{
                    workerType: 1,
                    thisWorker: 0,
                    zjCertificate: 0,
                    certificateWorker: 0
                }, {
                    workerType: 2,
                    thisWorker: 0,
                    zjCertificate: 0,
                    certificateWorker: 0
                }, {
                    workerType: 3,
                    thisWorker: 0,
                    zjCertificate: 0,
                    certificateWorker: 0
                }];
                for (var i = 0; i < unFormate.pWorkerSumList.length; i++) {
                    console.debug('unFormate.pWorkerSumList: ', unFormate.pWorkerSumList[i])
                    var turnType = unFormate.pWorkerSumList[i].workerType;
                    if (turnType == 1) {
                        this.percentArr.splice(0, 1, unFormate.pWorkerSumList[i]);
                    } else if (turnType == 2) {
                        this.percentArr.splice(1, 1, unFormate.pWorkerSumList[i]);
                    } else if (turnType == 3) {
                        this.percentArr.splice(2, 1, unFormate.pWorkerSumList[i]);
                    }
                }
                console.debug('unFormate.pWorkerProportion: ', unFormate.pWorkerProportion)
                this.munCount = unFormate.pWorkerProportion;
            })

        },
        memberEdit: function (dat) {
            let pathParams = {
                pressId: this.$route.query.pressId,
                mtId: this.$route.query.mtId,
                pressType: this.$route.query.pressType,
            }

            if (dat) {
                pathParams.id = dat.id;
            }

            this.$router.push({
                path: 'edsct_tab8',
                query: pathParams
            })
        },

        // urlCreate: function(mode,id) {
        //     if(mode == 'open'){
        //        this.imgShowUrl = process.env.BASE_API + '/File/File/view/token/' + this.$store.getters.fileToken + '/id/' + id;
        //        this.dialogVisible = true;
        //     }else if(mode == 'close'){
        //        this.imgShowUrl = '';
        //     }
        // },

        urlCreate: function (mode, id) {
            if (mode == 'open') {
                //  this.imgShowUrl = process.env.BASE_API + '/File/File/view/token/' + this.$store.getters.fileToken + '/id/' + id;
                getPfileUrl({ id }).then(response => {
                    this.imgShowUrl = response.payload.url
                })
                this.dialogVisible = true;
            } else if (mode == 'close') {
                this.imgShowUrl = '';
            }
        },

        pageSent: function (inx) {
            this.seekPms.no = inx;
            // this.tabSeek();
            this.currentPage = inx;
        },

        goBack: function () {
            this.$router.go(-1);
        },
        // 获取出版单位历史提交版本列表
        getHistoryList: function () {
            let that = this;
            pSubmitHistoryList({ publishMaterialId: this.$route.query.mtId }).then(response => {
                console.debug('pSubmitHistoryList: ', response)
                that.historyJson = response.pSubmitHistoryList;
                for (const list of response.pSubmitHistoryList) {
                    that.options.push({ 'value': list.createdAt, 'id': list.id })
                }
            })
        },
        // 获取出版单位历史提交json数据
        gethistory: function (id) {
            const that = this;
            for (const list of that.historyJson) {
                if (id == list.id) {
                    that.historyJsonParams = JSON.parse(list.afterJson);
                    that.historyDeclare = JSON.parse(list.submittor);
                }
            }
            // 获取图片
            getFileToken().then(data => {
                that.historyImgUrl = process.env.BASE_API + '/File/File/download/token/' + data.resultStatus.token + '/id/' + that.historyJsonParams.yyzzId;
            })
        },
        filterData: function (data, params) {
            console.debug('filterData: ', params.type, params.keyword)
            let text = params.keyword
            // if (!text || text.trim() === '') return data
            text = text.toLowerCase()
            let list = _.filter(data, x => {
                // if (params.type !=0 && x.type != params.type) return false
                return ((x.fullName && x.fullName.includes(text))
                    || (x.idNumber && x.idNumber.includes(text))
                    || (x.cellphone && x.cellphone.includes(text)))
                    && (params.type == 0 || x.type == params.type)
            })

            let pages = parseInt(list.length / this.pageSize);
            if (list.length % this.pageSize > 0) {
                pages += 1;
            }
            this.pgAll = pages;
            if (this.currentPage > this.pgAll) {
                this.seekPms.no = 1;
                this.currentPage = 1;
            }

            return list;
        }
    },
    mounted() {
        this.getHistoryList();
    },
    created: function () {
        this.seekPms.publishMaterialId = this.$route.query.mtId;
        this.dictInit();
        this.role = this.$route.query.role;

    }
}
</script>

<style lang="scss">
@import "src/styles/pressRoleL";

.Rtable8 {
    .highlight {

        .el-input__inner,
        .el-textarea__inner {
            color: red !important;
        }
    }

    .newStyle {
        margin: 30px 0 !important;
        width: 50% !important;
        overflow: hidden;
        float: left;
    }

    .selectTime {
        float: left;
        font-weight: normal;
        margin: -5px 30px;
    }

    .editBox {
        overflow: hidden;
    }

    .percentTab table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 30px;

        td {
            text-align: center;
            border: 1px solid #ebeef5;
            padding: 12px;
        }
    }

    .pageCage {
        padding: 30px 0px;
        text-align: center;
    }

    .imgIcon {
        cursor: pointer;
    }

    .ctrlsLine {
        padding: 12px;

        .el-radio__label {
            margin-left: -5px;
        }

        .el-input {
            display: inline-block;
            width: 360px;
            margin-left: 20px;

            input {
                border-radius: 0;
            }
        }

        .el-button+.el-button {
            margin-left: 0;
        }

        .el-radio+.el-radio {
            margin-left: 20px;
        }

        .seekBtn {
            margin-right: 20px;
        }
    }

    .headBar {
        padding: 0px 24px;
        height: 45px;
        line-height: 45px;
        background: #F8F8F8;
        color: #666666;
        margin-top: 12px;
    }

    .newEditArea {
        width: 80%;
        margin: 0 auto;
        padding: 30px;

        .editBox {
            width: 100%;
            height: auto;
            overflow: hidden;

            p {
                float: left;
                width: 100px;
                text-align: right;
            }

            .edInp {
                width: 300px;
                float: left;
                margin: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// table8.vue?61c80177